import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation ToggleAddDebitCardVisibility(
    $input: ToggleAddDebitCardVisibilityInput!
  ) {
    toggleAddDebitCardVisibility(input: $input) {
      __typename
      ... on ToggleAddDebitCardVisibilitySuccess {
        successMessage: message
        visibility {
          isVisible
        }
      }
      ... on ToggleAddDebitCardVisibilityError {
        ...error
      }
    }
  }
  ${error}
`;
